import React from 'react'
import { Link } from 'react-router-dom'
import { FormGroup, FormText } from 'reactstrap'

export default function FieldsetItemLarge(props) {
  const className = `mb-0 ${
    props.color ? `alert alert-${props.color} pt-0 pb-0` : ''
  }`
  const isLink = props.data && !!props.url
  const content = props.data ? props.data : props.children
  const labelContent = toString(content)
  return (
    <FormGroup className={className}>
      <FormText>{props.title}:</FormText>
      <h5 className="font-weight-bold">
        {isLink && <Link to={props.url}>{props.data}</Link>}
        {!isLink && labelContent}
      </h5>
    </FormGroup>
  )
}

const toString = data => {
  if (typeof data === 'boolean') return data ? 'True' : 'False'
  return data
}



// WEBPACK FOOTER //
// ./src/components/FieldsetItemLarge.js